import { useSelector } from 'react-redux'
import { Element } from '../../../../../common/html/element'
import { Loading } from '../../../../../common/loading'
import { typeViewBy } from '../../constant'
import classes from '../../index.module.scss'
import EachYear from './EachYear'
import Table from './Table'
import { selectLoading } from './store/slice'
import Trend from './trend'

const OperatingIncome = ({ viewBy, id, isDownloadComponent }) => {
  const loading = useSelector(selectLoading)

  return (
    <Element
      className={`h100 ${classes.containerPanel}`}
      style={{ color: '#3A414B' }}
    >
      {loading ? (
        <Loading />
      ) : viewBy === typeViewBy.TREND ? (
        <Trend id={id} isDownloadComponent={isDownloadComponent} />
      ) : viewBy === typeViewBy.EACH_YEAR ? (
        <EachYear id={id} isDownloadComponent={isDownloadComponent} />
      ) : (
        <Table id={id} />
      )}
    </Element>
  )
}

export default OperatingIncome
